(function BundleWizardPower() {
    const CONTAINER_ID = 'simple-bundles-io-options';
    const FORM_BUTTONS_SEL = '.product-form__buttons';

    function init(container) {
        const sections = parseSections(container);
        if (sections.length < 2) return;

        createWizard(container, sections);

        // --- DRIVER → LOFT FILTERING ---
        (function setupDriverLoftFiltering() {
            const driverSelect = [...document.querySelectorAll('label')]
                .find(l => l.textContent.trim() === 'FIRE TOUR DRIVER')
                ?.nextElementSibling;

            const loftSelect = [...document.querySelectorAll('label')]
                .find(l => l.textContent.trim() === 'Loft')
                ?.nextElementSibling;

            if (!driverSelect || !loftSelect) return;

            const allowed = {
                PRO: ['6°', '7.5°', '9°', '10.5°'],
                X: ['9°', '10.5°', '12°'],
                XX: ['9°', '10.5°', '12°', '14°']
            };

            const loftOptions = [...loftSelect.options].map(option => ({
                option,
                originalDisabled: option.disabled,
                originalHidden: option.hidden
            }));

            driverSelect.addEventListener('change', () => {
                let selected = driverSelect.dataset.driverType || '';

                if (!allowed[selected]) {
                    const selectedOption = driverSelect.options[driverSelect.selectedIndex];

                    const selectedText = `${driverSelect.value || ''} ${selectedOption?.textContent || ''}`
                        .trim()
                        .toUpperCase();

                    selected =
                        selectedText.includes('XX') ? 'XX' :
                            selectedText.includes('PRO') ? 'PRO' :
                                /\bX\b/.test(selectedText) ? 'X' :
                                    '';
                }

                loftOptions.forEach(({ option, originalDisabled, originalHidden }) => {
                    const text = option.textContent.trim();
                    const isPlaceholder = !option.value;
                    const isAllowed = allowed[selected]?.includes(text);

                    option.hidden = isPlaceholder ? originalHidden : !isAllowed;
                    option.disabled = isPlaceholder ? originalDisabled : !isAllowed;
                });

                const currentLoftText = loftSelect.options[loftSelect.selectedIndex]?.textContent.trim();

                if (!allowed[selected]?.includes(currentLoftText)) {
                    loftSelect.value = '';
                }
            });
        })();
        // --- DRIVER IMAGE SELECTOR ---
        (function setupDriverImageSelector() {
            const driverLabel = [...document.querySelectorAll('label')]
                .find(l => l.textContent.trim() === 'FIRE TOUR DRIVER');

            if (driverLabel) driverLabel.classList.add("bundle-top-label--driver");
            if (!driverLabel) return;

            const driverSelect = driverLabel.nextElementSibling;
            if (!driverSelect) return;
            driverSelect.style.display = "none";

            const wrapper = document.createElement('div');
            wrapper.className = "bundle-image__container";

            const options = [
                { value: "PRO", img: "https://cdn.shopify.com/s/files/1/0635/7437/6584/files/pro-tour-driver.webp?v=1764712269", label: "PRO" },
                { value: "X", img: "https://cdn.shopify.com/s/files/1/0635/7437/6584/files/x-tour-driver.webp?v=1764712269", label: "X" },
                { value: "XX", img: "https://cdn.shopify.com/s/files/1/0635/7437/6584/files/xx-tour-driver.webp?v=1764712269", label: "XX" }
            ];

            options.forEach(opt => {
                const item = document.createElement("div");
                item.className = "bundle-image__item";

                const img = document.createElement("img");
                img.className = "bundle-image__img";
                img.src = opt.img;
                img.alt = opt.label;

                img.addEventListener("click", () => {
                    driverSelect.dataset.driverType = opt.value;

                    const realOptions = [...driverSelect.options].filter(option => option.value);

                    const matchingOption = realOptions.find(option => {
                        const optionText = `${option.value} ${option.textContent}`.trim().toUpperCase();

                        if (opt.value === "PRO") return optionText.includes("PRO");
                        if (opt.value === "XX") return optionText.includes("XX");
                        if (opt.value === "X") return /\bX\b/.test(optionText) && !optionText.includes("XX");

                        return false;
                    });

                    const fallbackIndex = {
                        PRO: 0,
                        X: 1,
                        XX: 2
                    };

                    const finalOption = matchingOption || realOptions[fallbackIndex[opt.value]];

                    if (finalOption) {
                        driverSelect.value = finalOption.value;
                    }

                    [...wrapper.children].forEach(i => {
                        const imgEl = i.querySelector("img");
                        imgEl.style.transform = "scale(1)";
                        imgEl.style.boxShadow = "none";
                        imgEl.style.borderRadius = "0";
                    });

                    img.style.transform = "scale(1.06)";
                    img.style.boxShadow = "0 0 20px rgba(0,0,0,0.25)";
                    img.style.borderRadius = "8px";

                    driverSelect.dispatchEvent(new Event("change", { bubbles: true }));
                });

                const label = document.createElement("div");
                label.className = "bundle-driver-img-label";
                label.textContent = opt.label;

                item.appendChild(label);
                item.appendChild(img);
                wrapper.appendChild(item);
            });

            driverLabel.parentNode.insertBefore(wrapper, driverSelect);
        })();

        // --- FW LENGTH FILTERING ---
        (function setupFWLengthFiltering() {
            const fwLabel = [...document.querySelectorAll('label')]
                .find(l => l.textContent.trim() === 'FIRE FAIRWAY WOOD');
            if (fwLabel) fwLabel.classList.add("bundle-top-label--wood1");
            if (!fwLabel) return;

            const fwSelect = fwLabel.nextElementSibling;
            if (!fwSelect) return;

            let fwLengthSelect = null;
            let el = fwLabel;

            while (el = el.nextElementSibling) {
                if (el.tagName === 'LABEL' && el.textContent.trim() === 'Shaft Length') {
                    fwLengthSelect = el.nextElementSibling;
                    break;
                }
            }

            if (!fwLengthSelect) return;

            const originalFW = [...fwLengthSelect.options].map(o => ({
                value: o.value,
                text: o.textContent.trim()
            }));

            const allowedFW = {
                "2 Wood 10°": ["42", "42.5", "43 (Standard)", "43.5", "44"],
                "3+ Wood 13°": ["42", "42.5", "43 (Standard)", "43.5", "44"],
                "3 Wood 15°": ["42", "42.5", "43 (Standard)", "43.5", "44"],
                "5 Wood 19°": ["41", "41.5", "42 (Standard)", "42.5", "43"],
                "7 Wood 23°": ["40", "40.5", "41 (Standard)", "41.5", "42"],
                "9 Wood 27°": ["39.25", "39.75", "40.25 (Standard)", "40.75", "41.25"],
                "11 Wood 31°": ["38.75", "39.25", "39.75 (Standard)", "40.25", "40.75"],
                "13 Wood 35°": ["37.5", "38", "38.5 (Standard)", "39", "39.5"],
                "15 Wood 39°": ["37", "37.5", "38 (Standard)", "38.5", "39"]
            };

            fwSelect.addEventListener('change', () => {
                const chosen = fwSelect.value;
                fwLengthSelect.innerHTML = '';
                fwLengthSelect.appendChild(new Option('Please select', ''));

                const allow = allowedFW[chosen];
                if (!allow) return;

                originalFW.forEach(opt => {
                    if (allow.includes(opt.text)) {
                        fwLengthSelect.appendChild(new Option(opt.text, opt.value));
                    }
                });

                fwLengthSelect.value = '';
            });
        })();

        // --- FW IMAGE SELECTOR ---
        (function setupFWImageSelector() {
            const fwSelect = [...document.querySelectorAll('label')]
                .find(l => l.textContent.trim() === 'FIRE FAIRWAY WOOD')
                ?.nextElementSibling;
            if (!fwSelect) return;

            fwSelect.style.display = "none";

            const wrapper = document.createElement("div");
            wrapper.className = "bundle-image__container";
            fwSelect.parentNode.insertBefore(wrapper, fwSelect);

            const options = [
                { value: "2 Wood 10°", img: "https://cdn.shopify.com/s/files/1/0635/7437/6584/files/2-FFW.webp?v=1764721457", label: "2 Wood 10°" },
                { value: "3+ Wood 13°", img: "https://cdn.shopify.com/s/files/1/0635/7437/6584/files/3plus-FFW.webp?v=1764721457", label: "3+ Wood 13°" },
                { value: "3 Wood 15°", img: "https://cdn.shopify.com/s/files/1/0635/7437/6584/files/3-FFW.webp?v=1764721457", label: "3 Wood 15°" },
                { value: "5 Wood 19°", img: "https://cdn.shopify.com/s/files/1/0635/7437/6584/files/5-FFW.webp?v=1764721457", label: "5 Wood 19°" },
                { value: "7 Wood 23°", img: "https://cdn.shopify.com/s/files/1/0635/7437/6584/files/7-FFW.webp?v=1764721457", label: "7 Wood 23°" },
                { value: "9 Wood 27°", img: "https://cdn.shopify.com/s/files/1/0635/7437/6584/files/9-FFW.webp?v=1764721457", label: "9 Wood 27°" },
                { value: "11 Wood 31°", img: "https://cdn.shopify.com/s/files/1/0635/7437/6584/files/11-FFW.webp?v=1764721457", label: "11 Wood 31°" },
                { value: "13 Wood 35°", img: "https://cdn.shopify.com/s/files/1/0635/7437/6584/files/13-FFW.webp?v=1764721457", label: "13 Wood 35°" },
                { value: "15 Wood 39°", img: "https://cdn.shopify.com/s/files/1/0635/7437/6584/files/15-FFW.webp?v=1764721457", label: "15 Wood 39°" }
            ];

            options.forEach(opt => {
                const item = document.createElement("div");
                item.className = "bundle-image__item";

                const img = document.createElement("img");
                img.className = "bundle-image__img";
                img.src = opt.img;
                img.alt = opt.value;

                img.addEventListener("click", () => {
                    fwSelect.value = opt.value;
                    [...wrapper.children].forEach(i => {
                        const imgEl = i.querySelector("img");
                        imgEl.style.transform = "scale(1)";
                        imgEl.style.boxShadow = "none";
                        imgEl.style.borderRadius = "0";
                    });
                    img.style.transform = "scale(1.06)";
                    img.style.boxShadow = "0 0 20px rgba(0,0,0,0.25)";
                    img.style.borderRadius = "8px";

                    fwSelect.dispatchEvent(new Event('change', { bubbles: true }));
                });

                const label = document.createElement("div");
                label.className = "bundle-wood1-img-label";
                label.textContent = opt.label;

                item.appendChild(label);
                item.appendChild(img);
                wrapper.appendChild(item);
            });
        })();


        // ---------------------------------------------------------
        // *** MODIFIED MINI DRIVER SECTION — DROPDOWN ONLY ***
        // ---------------------------------------------------------
        (function setupMiniDropdown() {
            const miniLabel = [...document.querySelectorAll('label')]
                .find(l => l.textContent.trim() === 'FIRE TOUR MINI DRIVER');

            if (miniLabel) miniLabel.classList.add("bundle-top-label--wood2");
            if (!miniLabel) return;

            const miniSelect = miniLabel.nextElementSibling;
            if (!miniSelect) return;

            // SHOW ORIGINAL DROPDOWN
            miniSelect.style.display = "block";

            // --- INSERT STATIC IMAGE ABOVE THE LOFT LABEL ---
            const imgWrapper = document.createElement("div");
            imgWrapper.className = "bundle-image__container";
            imgWrapper.innerHTML = `
        <div class="bundle-image__item">
            <div class="bundle-wood2-img-label">11.5° Only</div>
            <img class="bundle-image__img"
                 src="https://cdn.shopify.com/s/files/1/0635/7437/6584/files/mini-driver.webp?v=1765381683"
                 alt="11.5° Only">
        </div>
    `;
            // insert the image ABOVE the select
            miniSelect.parentNode.insertBefore(imgWrapper, miniSelect);

            // --- YOUR ORIGINAL CODE (UNCHANGED) ---
            const loftLabel = document.createElement("label");
            loftLabel.textContent = "Loft";
            loftLabel.className = "bundle-section-label";

            miniSelect.parentNode.insertBefore(loftLabel, miniSelect);
        })();


        // ---------------------------------------------------------
        // --- POWER BUNDLE SOLD OUT OPTIONS ---
        (function setupPowerBundleSoldOutOptions() {

            // PRO DRIVER: LEFT HAND 6° AND 7.5° SOLD OUT
            const driverLabel = [...container.querySelectorAll('label')]
                .find(label =>
                    label.textContent.trim() === 'FIRE TOUR DRIVER'
                );

            const driverStep = driverLabel?.closest('.bw-step');
            const driverSelect = driverStep?.querySelector('select');

            const driverHandSelect = [...(driverStep?.querySelectorAll('label') || [])]
                .find(label => label.textContent.trim() === 'Hand')
                ?.nextElementSibling;

            const loftSelect = [...(driverStep?.querySelectorAll('label') || [])]
                .find(label => label.textContent.trim() === 'Loft')
                ?.nextElementSibling;

            if (driverSelect && driverHandSelect && loftSelect) {
                function updateDriverSoldOut() {
                    const selectedOption =
                        driverSelect.options[driverSelect.selectedIndex];

                    const driverText =
                        `${driverSelect.dataset.driverType || ''} ${driverSelect.value || ''} ${selectedOption?.textContent || ''}`
                            .toUpperCase();

                    const isProLeft =
                        driverText.includes('PRO') &&
                        driverHandSelect.value === 'Left Hand';

                    [...loftSelect.options].forEach(option => {
                        const originalText = option.textContent
                            .replace(/\s*-\s*Sold out$/i, '')
                            .trim();

                        if (!['6°', '7.5°'].includes(originalText)) {
                            return;
                        }

                        option.disabled = isProLeft || option.hidden;
                        option.textContent = isProLeft
                            ? `${originalText} - Sold out`
                            : originalText;

                        if (
                            isProLeft &&
                            loftSelect.value === option.value
                        ) {
                            loftSelect.value = '';
                            loftSelect.dispatchEvent(
                                new Event('change', { bubbles: true })
                            );
                        }
                    });
                }

                driverSelect.addEventListener(
                    'change',
                    updateDriverSoldOut
                );

                driverHandSelect.addEventListener(
                    'change',
                    updateDriverSoldOut
                );

                updateDriverSoldOut();
            }

            // FAIRWAY WOOD: LEFT HAND 11 WOOD AND 13 WOOD SOLD OUT
            const woodLabel = [...container.querySelectorAll('label')]
                .find(label =>
                    label.textContent.trim() === 'FIRE FAIRWAY WOOD'
                );

            const woodStep = woodLabel?.closest('.bw-step');
            const woodSelect = woodStep?.querySelector('select');

            const woodHandSelect = [...(woodStep?.querySelectorAll('label') || [])]
                .find(label => label.textContent.trim() === 'Hand')
                ?.nextElementSibling;

            if (!woodSelect || !woodHandSelect) return;

            const leftHandOption = [...woodHandSelect.options]
                .find(option =>
                    option.textContent
                        .replace(/\s*-\s*Sold out$/i, '')
                        .trim() === 'Left Hand'
                );

            if (!leftHandOption) return;

            function updateWoodSoldOut() {
                const isSoldOut = [
                    '11 Wood 31°',
                    '13 Wood 35°'
                ].includes(woodSelect.value);

                leftHandOption.disabled = isSoldOut;
                leftHandOption.textContent = isSoldOut
                    ? 'Left Hand - Sold out'
                    : 'Left Hand';

                if (
                    isSoldOut &&
                    woodHandSelect.value === leftHandOption.value
                ) {
                    woodHandSelect.value = '';
                    woodHandSelect.dispatchEvent(
                        new Event('change', { bubbles: true })
                    );
                }
            }

            woodSelect.addEventListener(
                'change',
                updateWoodSoldOut
            );

            updateWoodSoldOut();
        })();

    } // END INIT




    function parseSections(container) {
        const sectionMap = new Map();

        const GROUPS = {
            "FIRE TOUR DRIVER": "FIRE TOUR DRIVER",
            "FIRE FAIRWAY WOOD": "FIRE FAIRWAY WOOD",
            "FIRE TOUR MINI DRIVER": "FIRE TOUR MINI DRIVER"
        };

        Array.from(container.children).forEach(el => {
            if (el.tagName === 'LABEL') {
                const name = el.textContent.trim();
                let groupName = null;

                Object.keys(GROUPS).forEach(prefix => {
                    if (name.startsWith(prefix)) groupName = GROUPS[prefix];
                });

                if (groupName) {
                    if (!sectionMap.has(groupName)) {
                        sectionMap.set(groupName, { name: groupName, elements: [] });
                    }
                    sectionMap.get(groupName).elements.push(el);
                }
            } else if (el.tagName === 'SELECT') {
                const last = Array.from(sectionMap.values()).pop();
                if (last) last.elements.push(el);
            }
        });

        return Array.from(sectionMap.values());
    }


    function createWizard(container, sections) {
        let step = 0;
        const formButtons = document.querySelector(FORM_BUTTONS_SEL);

        // Cache selects
        const driverSelect = [...document.querySelectorAll('label')]
            .find(l => l.textContent.trim() === 'FIRE TOUR DRIVER')
            ?.nextElementSibling;

        const fwSelect = [...document.querySelectorAll('label')]
            .find(l => l.textContent.trim() === 'FIRE FAIRWAY WOOD')
            ?.nextElementSibling;

        const miniSelect = [...document.querySelectorAll('label')]
            .find(l => l.textContent.trim() === 'FIRE TOUR MINI DRIVER')
            ?.nextElementSibling;


        const tabBar = document.createElement('div');
        tabBar.className = 'bw-tabs';

        sections.forEach((section, i) => {
            const tabBtn = document.createElement('button');
            tabBtn.type = 'button';
            tabBtn.className = 'bw-tab';
            tabBtn.textContent = section.name;
            tabBtn.dataset.step = i;

            tabBtn.addEventListener('click', () => {
                step = i;
                render();
            });

            tabBar.appendChild(tabBtn);
            section.tab = tabBtn;
        });

        container.insertBefore(tabBar, container.firstChild);


        sections.forEach((section, i) => {
            const wrapper = document.createElement('div');
            wrapper.className = 'bw-step' + (i === 0 ? ' active' : '');
            wrapper.dataset.step = i;

            const header = document.createElement('h3');
            header.className = 'bw-step-header';
            header.textContent = `Select ${section.name} Options`;
            wrapper.appendChild(header);

            section.elements.forEach(el => {
                if (el.tagName === 'LABEL') {
                    el.classList.add("bundle-section-label");
                    el.textContent = el.textContent.replace(/^([^–-]+)\s*[–-]\s*/, '');
                }
                wrapper.appendChild(el);
            });

            container.appendChild(wrapper);
            section.wrapper = wrapper;
            section.selects = wrapper.querySelectorAll('select[required]');
        });


        const nav = document.createElement('div');
        nav.className = 'bw-nav';
        nav.innerHTML = `
          <button type="button" class="bw-prev button button--secondary bw-hidden">Previous</button>
          <button type="button" class="bw-next button button--secondary"></button>
        `;
        container.appendChild(nav);

        const prevBtn = nav.querySelector('.bw-prev');
        const nextBtn = nav.querySelector('.bw-next');


        const isFilled = section =>
            Array.from(section.selects).every(sel => sel.value);

        const allFilled = () => sections.every(isFilled);


        function render() {
            sections.forEach((s, i) => {
                s.wrapper.classList.toggle('active', i === step);
                if (s.tab) s.tab.classList.toggle('active', i === step);
            });

            prevBtn.classList.toggle('bw-hidden', step === 0);

            const isLast = step === sections.length - 1;

            if (isLast) {
                nextBtn.classList.add('bw-hidden');
                formButtons?.classList.toggle('bw-hidden', !allFilled());
            } else {
                nextBtn.classList.remove('bw-hidden');
                nextBtn.textContent = `Next: ${sections[step + 1].name}`;
                formButtons?.classList.add('bw-hidden');
            }
        }


        prevBtn.addEventListener('click', () => {
            if (step > 0) { step--; render(); }
        });


        nextBtn.addEventListener('click', () => {

            if (step === 0 && (!driverSelect || !driverSelect.value)) {
                Swal.fire({
                    icon: 'warning',
                    title: 'Selection Required',
                    text: 'Please select a FIRE TOUR DRIVER before continuing.',
                    confirmButtonText: 'OK'
                });
                return;
            }

            if (step === 1 && (!fwSelect || !fwSelect.value)) {
                Swal.fire({
                    icon: 'warning',
                    title: 'Selection Required',
                    text: 'Please select a FIRE FAIRWAY WOOD before continuing.',
                    confirmButtonText: 'OK'
                });
                return;
            }

            if (step === 2 && (!miniSelect || !miniSelect.value)) {
                Swal.fire({
                    icon: 'warning',
                    title: 'Selection Required',
                    text: 'Please select a FIRE TOUR MINI DRIVER before continuing.',
                    confirmButtonText: 'OK'
                });
                return;
            }


            if (!isFilled(sections[step])) {
                sections[step].selects.forEach(sel => {
                    if (!sel.value) sel.reportValidity();
                });
                return;
            }

            step++;
            render();
        });


        container.addEventListener('change', render);
        render();
    }




    function observe() {
        const el = document.getElementById(CONTAINER_ID);
        if (el) {
            init(el);
            return true;
        }
        return false;
    }


    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
            if (!observe()) {
                new MutationObserver((_, obs) => {
                    if (observe()) obs.disconnect();
                }).observe(document.body, { childList: true, subtree: true });
            }
        });
    } else if (!observe()) {
        new MutationObserver((_, obs) => {
            if (observe()) obs.disconnect();
        }).observe(document.body, { childList: true, subtree: true });
    }

})();


// CHOOSE YOUR PATCH
new MutationObserver(() => {
    const lbl = document.querySelector('.bundle-top-label--driver');
    const lbl2 = document.querySelector('.bundle-top-label--wood1');
    const lbl3 = document.querySelector('.bundle-top-label--wood2');

    if (lbl && !lbl.dataset.patched) {
        lbl.textContent = "Choose your " + lbl.textContent.trim();
        lbl.dataset.patched = "1";
    }

    if (lbl2 && !lbl2.dataset.patched) {
        lbl2.textContent = "Choose your " + lbl2.textContent.trim();
        lbl2.dataset.patched = "1";
    }

    if (lbl3 && !lbl3.dataset.patched) {
        lbl3.textContent = "Choose your " + lbl3.textContent.trim();
        lbl3.dataset.patched = "1";
    }
}).observe(document.body, { childList: true, subtree: true });
